import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    initiateLiveChat,
    searchWhatsAppMsgTemplate,
    sendWhatsAppMessage,
} from "../../store/actions/tenantAction";
import {
    getVariableComponent,
    onSelectTemplate,
} from "../../utils/TemplateHelper";
import { getInfo, getWaba, LOGIN_INFO, saveWaba, SHOW_SNACKBAR, WABA } from "../../utils/types";
import WhatsAppTemplatePreview from "../../components/WhatsAppTemplatePreview";
import TypeableSelect from "../../components/Dropdowns/TypeableSelect";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import SetTemplateVariableValue from "../../layouts/tenant/SetTemplateVariableValue";

function NewChatPage() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let location = useLocation();
    const globalReducer = useSelector((state) => state.globalReducer);
    const [phoneNumbar, setPhoneNumbar] = useState("");
    const [templates, setTemplates] = useState([]);
    const [template, setTemplate] = useState({
        templateType: "GENERIC",
        category: "MARKETING",
        language: "English",
        header: { type: "HEADER", format: "" },
        body: "",
        footer: "",
        buttons: [],
    });
    const [selectedTemplate, setSelectedTemplate] = useState({});
    const [selectedTemplateId, setSelectedTemplateId] = useState();
    const [carouselTemplate, setCarouselTemplate] = useState([]);
    const loginInfo = getInfo();

    useEffect(() => {
        dispatch({ type: LOGIN_INFO, payload: loginInfo });
        dispatch({ type: WABA, payload: getWaba() });
        window.receiveFromFlutter = (d) => {
            const data = typeof d === 'string' ? JSON.parse(d) : d;
            if (data?.waba) {
                saveWaba(data?.waba);
                dispatch({ type: WABA, payload: data?.waba });
            }
        };
    }, []);

    useEffect(() => {
        if (globalReducer?.loginInfo?.tenantId && globalReducer.waba?.id) {
            dispatch(
                searchWhatsAppMsgTemplate(
                    {
                        tenantId: globalReducer.loginInfo?.tenantId,
                        criteria: {
                            active: true,
                            tenantWabaId: globalReducer.waba?.id,
                            status: "APPROVED",
                        },
                        size: 100000,
                        offset: 0,
                        orderBy: [{ property: "id", direction: "DESC" }]
                    },
                    (swt) => {
                        setTemplates(swt.data ?? []);
                    }
                )
            );
        }
    }, [globalReducer.waba]);

    useEffect(() => {
        if (selectedTemplateId && templates?.length > 0) {
            onSelectTemplate(
                templates,
                setSelectedTemplate,
                setTemplate,
                setCarouselTemplate,
                selectedTemplateId
            );
        }
    }, [selectedTemplateId, templates]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        getVariableComponent(
            dispatch,
            globalReducer.loginInfo,
            globalReducer.waba,
            template,
            carouselTemplate
        ).then((componentsVal) => {
            if (componentsVal) {
                phoneNumbar?.split(",")?.map((phone) => {
                    dispatch(sendWhatsAppMessage({
                        tenantId: globalReducer.loginInfo?.tenantId,
                        contact: {
                            uid: globalReducer.loginInfo?.uid,
                            tenantId: globalReducer.loginInfo?.tenantId,
                            whatsappNumber: parseInt((phone + "")?.replace("+", ""))?.toString(),
                        },
                        tenantWabaId: globalReducer.waba?.id,
                        templateId: parseInt(selectedTemplateId),
                        template: selectedTemplate,
                        languageCode: selectedTemplate.language,
                        messageType: selectedTemplate.messageType,
                        type: "template",
                        templateValue: { components: componentsVal },
                    }, (a) => {
                        dispatch(
                            initiateLiveChat(a, (d) => {
                                dispatch({
                                    type: SHOW_SNACKBAR,
                                    payload: {
                                        type: "success",
                                        message: `Message sent`,
                                        open: true,
                                    },
                                });
                                try {
                                    setTimeout(() => {
                                        window.FlutterLogger.postMessage(JSON.stringify({ type: "BACK_BTN_CLICK" }));
                                    }, 200);
                                } catch { }
                            })
                        );
                    }));
                });
            }
        });
    };

    return (
        <div className="h-screen overflow-hidden flex flex-col bg-gray-50">

            {/* Fixed Header */}
            <div className="fixed top-0 left-0 right-0 transition-all duration-200 ease-out z-30 bg-white">
                <div className="flex gap-3 justify-between px-4 sm:px-5 py-[8.5px] min-h-[54px] text-base bg-white border-b border-[#e9ebf0]">
                    <div
                        className="flex gap-2 items-center my-auto font-medium text-black whitespace-nowrap cursor-pointer"
                        onClick={() => {
                            try { window.FlutterLogger.postMessage(JSON.stringify({ type: "BACK_BTN_CLICK" })); } catch { }
                        }}
                    >
                        <i className="fa-solid fa-angle-left"></i>
                        <i className="fa-solid fa-message text-[14px] text-theme"></i>
                        <div className="text-[14px] font-medium">{t("New Chat")}</div>
                    </div>
                    <div className="flex gap-2"></div>
                </div>
            </div>

            {/* Scrollable Content — between fixed header (54px) and fixed footer (57px) */}
            <form id="new-chat-form" onSubmit={handleSubmit}>
                <div
                    className="overflow-y-auto grid grid-cols-1 lg:grid-cols-12"
                    style={{ height: "calc(100vh - 54px - 57px)", marginTop: "54px" }}
                >
                    {/* Left: Form Fields */}
                    <div className="px-3 sm:px-5 py-5 lg:col-span-7 bg-gray-50">
                        <div className="grid gap-4 w-full">
                            {/* Phone Number */}
                            <div className="w-full">
                                <label className="block text-sm rtl:text-right text-gray-600 font-medium mb-2">
                                    {t("Enter WhatsApp Number")}
                                    <span className="text-red-500 text-sm">*</span>
                                </label>
                                <div className="relative rounded-md shadow-sm">
                                    <input
                                        required
                                        value={phoneNumbar}
                                        type="text"
                                        className="block w-full rounded-md border-gray-300 pr-5 rtl:pl-10 placeholder:text-[13px] placeholder:text-gray-400 focus:border-primary focus:outline-none text-sm"
                                        placeholder={t("Enter WhatsApp Number with country code")}
                                        onChange={(e) => setPhoneNumbar(e.target.value)}
                                    />
                                </div>
                            </div>

                            {/* Template Select */}
                            <div className="w-full">
                                <label className="text-sm text-gray-600 font-medium" id="headlessui-listbox-label-:rq:">
                                    {t("Message Template")}
                                    <span className="text-red-500 text-sm">*</span>
                                </label>
                                <TypeableSelect
                                    list={templates}
                                    selected={selectedTemplate}
                                    labelField="name"
                                    valueField="id"
                                    required={true}
                                    placeholder={t("Select Template")}
                                    onSelect={(s) => {
                                        if (s) {
                                            setSelectedTemplateId(s?.id);
                                            setSelectedTemplate(s);
                                        }
                                    }}
                                />
                            </div>

                            {/* Template Variable Values */}
                            <div className="w-full pt-3 border-t border-gray-300 mapDesign">
                                <label className="block text-sm rtl:text-right text-gray-600 font-medium mb-2">
                                    {t("Set Template Variable Value")}
                                </label>
                                <SetTemplateVariableValue
                                    tenantId={globalReducer.loginInfo?.tenantId}
                                    wabaId={globalReducer.waba?.id}
                                    setTemplate={setTemplate}
                                    template={template}
                                    carouselTemplate={carouselTemplate}
                                    setCarouselTemplate={setCarouselTemplate}
                                />
                            </div>

                            {/* Preview — mobile only (below form fields) */}
                            <div className="w-full pt-3 border-t border-gray-300 lg:hidden">
                                <div className="flex justify-center">
                                    <WhatsAppTemplatePreview
                                        wabaIco={globalReducer.waba?.teamImage}
                                        timezone={globalReducer.waba?.timezone}
                                        chatPhone={`+${globalReducer.waba?.phoneCode} ${globalReducer.waba?.phone}`}
                                        template={template}
                                        carouselTemplate={carouselTemplate}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right: Preview — desktop only */}
                    <div className="hidden lg:flex flex-col items-center bg-white p-4 lg:col-span-5 border-l border-gray-200 overflow-y-auto">
                        <h1 className="w-full text-[14px] font-medium leading-7 capitalize text-gray-900 text-center mb-2">
                            {t("Preview")}
                        </h1>
                        <div className="w-full flex justify-center">
                            <WhatsAppTemplatePreview
                                wabaIco={globalReducer.waba?.teamImage}
                                timezone={globalReducer.waba?.timezone}
                                chatPhone={`+${globalReducer.waba?.phoneCode} ${globalReducer.waba?.phone}`}
                                template={template}
                                carouselTemplate={carouselTemplate}
                            />
                        </div>
                    </div>
                </div>
            </form>

            {/* Fixed Footer — Send button */}
            <div className="fixed bottom-0 left-0 right-0 z-20 flex justify-end px-4 sm:px-5 py-[10px] bg-white border-t border-[#eeeeee]">
                <button
                    type="submit"
                    form="new-chat-form"
                    className="min-w-[100px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary"
                >
                    {t("Send")}
                </button>
            </div>

        </div>
    );
}

export default NewChatPage;
